var t=function(t,a){var n=a||this;return function(){t.apply(n,arguments)}};export{t as default};
